import { render, staticRenderFns } from "./GradesChart.vue?vue&type=template&id=8609fa9a&scoped=true"
import script from "./GradesChart.vue?vue&type=script&lang=js"
export * from "./GradesChart.vue?vue&type=script&lang=js"
import style0 from "./GradesChart.vue?vue&type=style&index=0&id=8609fa9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8609fa9a",
  null
  
)

export default component.exports